import { useCallback, useRef } from 'react';
import type { FlatListProps } from 'react-native';
import { bridge } from 'shared/src/utils';
import type { GoodsData } from '@banhala/ui-kit';
import type { CodiGoodsItem } from 'shared/src/api';

const SCREEN_NAME = 'GOODS_DETAIL';

export const useLogDisplayGoods = () => {
  const goodsItemLoggedList = useRef<Array<number>>([]);

  const logDisplayGoods = useCallback<
    NonNullable<
      FlatListProps<GoodsData & CodiGoodsItem>['onViewableItemsChanged']
    >
  >(({ viewableItems }) => {
    viewableItems.forEach(({ index, isViewable, item }) => {
      if (index === null || !isViewable) {
        return;
      }
      if (goodsItemLoggedList.current.includes(index)) {
        return;
      }
      goodsItemLoggedList.current.push(index);

      bridge.logAnalyticsEvent({
        channel: ['amplitude', 'ablylog', 'firebase'],
        name: 'DISPLAY_GOODS',
        analytics: {
          SCREEN: SCREEN_NAME,
          ...item.logging.analytics,
          INDEX: index,
        },
      });
    });
  }, []);

  return { logDisplayGoods };
};
